import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
    Box,
    VStack,
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';

import AvailableServiceProfiles from './add/AvailableServiceProfiles';
import getAvailableServiceProfiles from 'API/ServiceProfiles/getAvailableServiceProfiles';

import styles from './styles';
import { breadCrumbStyling } from 'components/forms/new/formStyles';

const ServiceWizard = ({ serviceWizard }) => {
    // Global
    const { currentCompany } = useSelector((state) => state.navigationLists);

    // Local
    const [serviceProfiles, setServiceProfiles] = useState(null);

    useEffect(() => {
        const handleGetData = async () => {
            if (currentCompany) {
                const serviceprofiles =
                    await getAvailableServiceProfiles(currentCompany);
                setServiceProfiles(serviceprofiles);
            }
        };

        handleGetData();
    }, [currentCompany]);

    const titleName = 'Add New Service';
    const breadCrumbTrail = [
        {
            label: 'Dashboard Services',
            path: '',
        },
        {
            label: titleName,
            path: '',
        },
    ];

    return (
        <Box sx={styles.container}>
            <Breadcrumb sx={breadCrumbStyling}>
                {breadCrumbTrail?.map((crumb, index) => (
                    <BreadcrumbItem key={index}>
                        <BreadcrumbLink
                            as={Link}
                            to={crumb.path}
                            onClick={() =>
                                index === 0 && serviceWizard.reset()
                            }>
                            {crumb.label}
                        </BreadcrumbLink>
                    </BreadcrumbItem>
                ))}
            </Breadcrumb>
            <VStack align="flex-start" width="100%">
                <AvailableServiceProfiles
                    serviceProfiles={serviceProfiles}
                    serviceWizard={serviceWizard}
                />
            </VStack>
        </Box>
    );
};

export default ServiceWizard;
